// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3VGu3","title":"AfterFrontImage_title__3YWSQ"};